"use client";

import { Button } from "@/components/buttons/Button";
import { Title } from "../Title";

interface ProfileEditProps {
    title: string;
    onSave: () => void;
    saveLabel?: string;
    saveDisabled?: boolean;
    firstColumnContent: React.ReactNode;
    secondColumnContent: React.ReactNode;
}

export default function ProfileEdit({
    title,
    onSave,
    saveLabel = "שמור וחזור לפרופיל",
    saveDisabled = false,
    firstColumnContent,
    secondColumnContent,
}: ProfileEditProps) {
    return (
        <>
            <Title title={title} />

            <div className="flex flex-1 flex-col justify-between">
                <form>
                    <div className="flex flex-col gap-1 desktop-2-columns">
                        <div className="flex flex-col gap-1">
                            {firstColumnContent}
                        </div>

                        <div className="flex flex-col gap-1">
                            {secondColumnContent}
                        </div>
                    </div>
                </form>

                <div className="flex flex-col gap-2">
                    <Button
                        variant="primary"
                        disabled={saveDisabled}
                        onClick={async () => {
                            await onSave();
                        }}
                    >
                        {saveLabel}
                    </Button>
                </div>
            </div>
        </>
    );
}
